import React from 'react';
import SvgSev0 from '@icons/price-alert-sev0.svg?react';
import SvgSev1 from '@icons/price-alert-sev1.svg?react';
import SvgSev2 from '@icons/price-alert-sev2.svg?react';
import SvgSev3 from '@icons/price-alert-sev3.svg?react';
import SvgSev4 from '@icons/price-alert-sev4.svg?react';
import { AiPriceAlertSeverityEnum } from '@api/ringil-api.v2.tsx';
import { AiAlertButton } from '@components/ai/AiAlertButton.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { getSeverityClassName } from '@components/ai/aiPriceAlertSeverity.ts';

export type AiButtonProps = {
  severity?: AiPriceAlertSeverityEnum;
};

export const AiPriceAlertButton: React.FC<AiButtonProps> = ({
                                                              severity,
                                                            }) => {

  const { tr } = useTranslationLgs();

  function getSeverityIcon(severity?: AiPriceAlertSeverityEnum) {
    switch (severity) {
      case AiPriceAlertSeverityEnum.SEVERITY_4:
        return <SvgSev4 />;
      case AiPriceAlertSeverityEnum.SEVERITY_3:
        return <SvgSev3 />;
      case AiPriceAlertSeverityEnum.SEVERITY_2:
        return <SvgSev2 />;
      case AiPriceAlertSeverityEnum.SEVERITY_1:
        return <SvgSev1 />;
      case AiPriceAlertSeverityEnum.SEVERITY_0:
        return <SvgSev0 />;
      default:
        return <></>;
    }
  }


  return (
    <AiAlertButton
      title={
        <span>
          {tr('AiPriceAlertButton.title', 'Price Alert')}
        </span>
      }
      subIcon={getSeverityIcon(severity)}
      className={getSeverityClassName(severity)}
    />
  );
};